const tabToggleSelector = '.js--tab-button';
const tabContentSelector = '.js--tab-content';
const activeClass = 'js--tab-active';

/**
 * Initialize tabs
 * @param {string} containerSelector - Selector of the container with tabs
 * TODO: refactor active tab with aria attributes aria-selected="true" and other data-attributes
 */

function initTabs(containerSelector: string): void {
  const container = document.querySelector(containerSelector);
  if (!container) {
    return;
  }

  const toggles = container.querySelectorAll(tabToggleSelector);
  const contentTabs = container.querySelectorAll(tabContentSelector);

  let tabName: string;

  toggles.forEach((toggle, index) => {
    if (!index) {
      toggles[0].classList.add(activeClass);
      contentTabs[0].classList.add(activeClass);
    }
    toggle.addEventListener('click', selectTab);
  });

  function selectTab() {
    toggles.forEach(toggle => {
      toggle.classList.remove(activeClass);
    });

    this.classList.add(activeClass);
    tabName = this.dataset.tab;
    selectTabContent(tabName);
  }

  function selectTabContent(tabName: string) {
    contentTabs.forEach(contentTab => {
      contentTab.classList.contains(tabName)
        ? contentTab.classList.add(activeClass)
        : contentTab.classList.remove(activeClass);
    });
  }

  function init() {
    container.classList.add('visible');
  }

  init();
}

export default initTabs;
